import { Role } from 'src/constants/types';

export const PARTNER_ID = 1990;
export const ADMINISTRATOR_ID = 1;
export const MODERATOR_ID = 1500;
export const RESTRICTED_ID = 30;

export const communityAdminRoles = [Role.Partner, Role.Administrator, Role.Moderator];
